import React, { useState, useContext, useEffect } from "react";
import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  Button,
  StatusDot,
  Checkbox,
  Subheader,
  Head,
  Table,
  Card,
  TreeSelect,
  Pagination,
  Input,
  RadioGroup,
  TagSelector,
  Switch,
  Icon,
  ButtonAction,
  ContentBlock,
  Tag,
  Notification
} from "xsolla-uikit";
import { getFakeStatuses, sources, getFakeSubs, getFakeSource, getFakeAuths, getUserAvatars } from "../data";
import { users } from "../data/users";

import {
  ButtonSquare,
  PAinfoCollapsible,
  PAtableFilter,
  CssClick,
  CssThTd,
  CssThFilt0,
  CssCounter,
  PaSelectMultiple
} from './uikit2';

import styled, { css } from "styled-components";

export function PAusers({
  handleClick = () => {
    void 0;
  },
}) {







  let colsInitial = [
    'id',
    'groups',
    'last_login',
    'auth',
  ]



  const rows = [...users]

  const [cols, setCols] = useState([...setPlain(columns)])







  useEffect(() => {
    console.log('cols = ', cols);
  }, [cols])


  const filterCols = (columns)=> {
    let a = []
    let b = cols.map((oneC) => (oneC['id']))

    columns.forEach((opt) => {
      if (b.indexOf(opt['id']) > -1) {
        a.push(opt)
      }
    })
    debugger
    return a;
  }



  return (<CssTableFont>

          <FormGroup>
            <PAusersTableFilter cols={cols} setCols={(c)=> setCols([...setPlain(c)])} />
          </FormGroup>


          <FormGroup indentation="xs">
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <div className="">
                <strong>123,332 users total</strong>
              </div>
              <div style={{display: 'flex',}}>
                Export&nbsp;&nbsp;
                <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>XLS</Button>&nbsp;&nbsp;
                <Button appearance="secondary" size="sm" appearance="flatten"><Icon name="download"/>CSV</Button>
              </div>
            </div>
          </FormGroup>

          <Table
            compact={true}
            renderEmptyMessage = {()=><div>
              <FormGroup>
                No users yet
              </FormGroup>
            </div>}
            style={{width: '100%'}}
            horizontalScroll={true}
            columns={cols}
            rows={rows}
          />

  </CssTableFont>)
}


export const CssTableFont = styled.span`
  & .xsui-table-cell__text {
    font-size: 14px;
  }
`;




export const CssTree = styled.span`
  & .xsui-tree-select__container {
    width: 280px;
    padding: 8px;
    left: 94%;
  }
`;












const columns = [{
  width: '20%',
  id: 'id',
  name: 'Username/ID',
  label: 'Username/ID', //TODO: чистый текст для выпадушки
  fieldGetter: (rw)=> {
    return   (
      <div className="l_flex">

        <div className="login-user-list-container__user-info__image-container">
          <div
            className="login-user-list-container__user-info__image"
            // style={{backgroundImage:`url(${rw['picture']})`}}
            style={{backgroundImage:`url(${getUserAvatars(0.3)})`}}
          />
        </div>


        <div className="ui-table__column ui-table__column--indentation-sm">
          <div>
            {rw['email'] ? rw['email'] : 'No email'}
          </div>
          <div style={{color: '#747e8a'}}>
            {rw['id']}
          </div>
        </div>

      </div>

    )
  }
},

{
  width: '8%',
  id: 'groups',
  name: 'User Group',
  label: 'User Group',
  fieldGetter: ({groups}) => groups[0]['name']
},
{
  width: '10%',
  id: 'last_login',
  name: 'Last logged in',
  label: 'Last logged in',
  // fieldGetter: ({last_login}) => <div>{last_login.indexOf(':')}</div>
  fieldGetter: ({last_login}) => <div>{last_login}</div>
},
{
  width: '10%',
  id: 'auth',
  name: 'Autorization method',
  label: 'Autorization method',
  fieldGetter: ()=> getFakeAuths()['label']
},
{
  width: '20%',
  id: 'source',
  label: "User source",
  name: <div className="l_flex">User source
    <PAtableFilter
      position = 'bottom'
      tooltip="Filter by currency"
      align="right"
      size="lg"
      // searchable={true}
      // handleFilter={setFilterCurr}
      options={[
        ...sources
      ]}
    />
  </div>,
  fieldGetter: ()=> {
    let s = getFakeSource();
    return (
      <div className="ui-table__column ui-table__column--indentation-sm">
          <div className="login-user-list-container__user-info__id">
            {s['type']}
          </div>
          <div className="login-user-list-container__user-info__groups">
            {s['label']}
          </div>
      </div>
    )
    }
  },
]



const setPlain = (cols)=> {
  let a = []
  cols.forEach((opt) => {
    a.push({
      ...opt,
      id: opt.id,
      label: opt.label,
    })
  })
  return a;
}












export const PAusersTableFilter = ({
  handleColumns = ()=>void(0),
  history,
  cols = [],
  setCols = ()=>void(0),
}) => {



  return (
    <FormGroup indentation="xs">
      <div
        style={{
          display: "grid",
          // gridTemplateColumns: "repeat( auto-fit, minmax(160px, 1fr) )",
          gridTemplateColumns: '2fr 1fr 200px',
          gridColumnGap: 16,
        }}
      >





        <FormGroup label="Search" indentation="xs">
          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 44px',
            gridColumnGap: 16}}
          >
            <Input
              key="1"
              size="sm"
              offset="left"
              icon="search"
              placeholder="Username or email"
              input={{
                label:  "1"
                // onFocus: handleFocus,
                // onChange: e => {
                //   let val = e.target.value;
                //   setInp(val);
                // }
              }}
            />
            <ButtonSquare><Icon name="search"/></ButtonSquare>
            </div>
          </FormGroup>

<div className=""></div>



        <FormGroup label="Show columns">

      <CssTree>
          <TreeSelect
              size="sm"
              // disabled={this.disabled}
              searchable={true}
              name="basic"
              allowMultiSelect={true}
              input={{
                value: cols,
                onChange: multiple => setCols(multiple)
              }}
              options={setPlain(columns)}
              // options={options}
              />
      </CssTree>


        </FormGroup>

      </div>







    </FormGroup>
  );
};




const options = [
  {id: 3, label: 'Planes'},
  {id: 4, label: 'Tanks'},
  {id: 5, label: 'Sharks'},
  {id: 6, label: 'Other'}
]
